import { Component, Input, ChangeDetectionStrategy, Injector, TemplateRef, QueryList, ContentChildren } from '@angular/core'
import { Store } from '@ngrx/store'
import { NavController } from 'ionic-angular'
import { UIEventHub } from '../../../services/event.service'
import { ActionCreator } from '../../../services/action.service'
import { ViewModel } from '../../../view-model'
import { BaseWidget } from '../../base-widget'
/**
 * 行選択カラム
 *【内容:content:string】
 *【チェックリスト:checkList:any[]】
 *【非活性:disabled:boolean】
 *【チェックフラグ:checked:boolean】
 *【表示条件:visible:boolean】
 * @author nabla2.metamodel.generator
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-row-selected-column',
  templateUrl: './row-selected-column.html',
  styles: [`
    
  `]
})
export class RowSelectedColumn extends BaseWidget {
  /**
   * 子要素
   */
  children:TemplateRef<any>[]

  @ContentChildren(TemplateRef) templateRefs:QueryList<TemplateRef<any>>

  ngAfterContentInit() {
    this.children = this.templateRefs.toArray()
  }
  /**
   * 項目添字
   */
  @Input() index:number

  /**
   * リスト内容
   */
  @Input() records:any[]

  /**
   * チェックリストの表示モデルパス
   */
  @Input() viewModelPath:string

  /**
   * チェックリストに対する精査エラー
   */
  @Input() errorMessages:{modelPath:string, message:string}[]

  /**
   * 内容
   */
  @Input() content:string

  /**
   * チェックリスト
   */
  @Input() checkList:any[]

  /**
   * 非活性
   */
  @Input() disabled:boolean

  /**
   * チェックフラグ
   */
  @Input() checked:boolean

  /**
   * 表示条件
   */
  @Input() visible:boolean

  /**
   * コンストラクタ
   * @param navCtrl 画面遷移管理サービス
   * @param store Reduxストア
   */
  constructor(
    public navCtrl: NavController,
    public store: Store<{viewModel:ViewModel}>,
    public eventHub: UIEventHub,
    public actionCreator: ActionCreator,
    public injector: Injector,
  ) {
    super(injector)
  }
  get htmlId():string {
    return `${this.id}[${this.index}]`
  }
  get checkedState(): boolean {
    return !!this.checkList && this.checkList.findIndex(a => a.rowIndex === this.index) !== -1;
  }
  updateChecked(event:Event, index:number): boolean {
    let target = this.records[index];
    if (!this.checkList || this.checkList.findIndex(a => a.rowIndex === this.index) === -1) {
      this.checked = true;
      target.rowIndex = index;
      this.checkList.push(target);
    } else {
      this.checked = false;
      this.checkList.forEach((each, targetIndex) => {
        if (each.rowIndex === index) {
          this.checkList.splice(targetIndex, 1);
        }
      });
    }
    const value:any[] = this.checkList.sort();
    this.store.dispatch(this.actionCreator.updateViewModel(
      this.viewModelPath,
      (m) => value,
      {id:this.id, type:event.type, source:event, index:index},
      `update by ${this.id}`,
    ));
    this.on(event, index);
    return this.checked ? !this.checked : this.checked;
  }
  /**
   * このコンポーネントの状態をバインドされた表示項目の状態に反映する。
   * @param event イベント
   */
  update(event:Event) {
    const node = <HTMLFormElement>event.target
    const value = node.value
    this.store.dispatch(this.actionCreator.updateViewModel(
      this.viewModelPath,
      (m) => value,
      {id:this.id, type:event.type, source:event},
      `update by ${this.id}`,
    ))
    this.on(event)
  }
}


// WEBPACK FOOTER //
// ./src/widgets/table/row-selected-column/row-selected-column.component.ts